module.exports = __webpack_public_path__ + "static/media/icn_home_active.da49f3c7.svg";